import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

import { ApiDownService } from '~app-client/api-down/services';

@Injectable({
	providedIn: 'root',
})
export class ApiDownGuard implements CanActivate {
	constructor(
		private apiDownService: ApiDownService,
		private router: Router
	) {}

	private createUrlTree(urls: string[]): UrlTree {
		return this.router.createUrlTree(urls, {
			queryParamsHandling: 'preserve',
		});
	}

	private async guard(): Promise<boolean | UrlTree> {
		return await new Promise<boolean | UrlTree>((resolve) => {
			const canNavigate = this.apiDownService.shouldNavigateToError;

			if (!canNavigate) {
				resolve(this.createUrlTree(['/']));
			} else {
				resolve(true);
			}
		});
	}

	async canActivate(): Promise<boolean | UrlTree> {
		return await this.guard();
	}
}
